import { Typography, Divider, Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SIZES } from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { useSiteConfiguration } from '@hapana/shared/web/hooks/siteConfiguration.hooks'
import { defaultTimeZoneFormat, parseFlexibleDate } from '@hapana/shared/utils/date.util'

import { styles } from '../notes-properties.styles'
import PropertyAlert from '../property-alert.component'
import { TABS_VALUES } from '../modal-alerts.constants'

const ModalShowAllProperties = ({ alerts, username }) => {
  const { t } = useTranslation(['checkIn'])
  const { data } = useSiteConfiguration()
  const { popDialog } = useDialog()

  const handleBackClick = () => {
    popDialog({ tabDefaultValue: TABS_VALUES[1] })
  }

  const formattedDate = (date) => {
    const parsed = parseFlexibleDate(date)
    return parsed ? defaultTimeZoneFormat(parsed, data?.timezone) : ''
  }

  const verifyTitle = (item) => (item.title === null ? formattedDate(item.date) : item.title)

  return (
    <DialogLayout
      size={SIZES.SM}
      hasBackLabel
      onCustomBackClick={handleBackClick}
      customBackLabel={
        t('checkIn:alerts.notesAndPropertiesHeader', {
          username,
        }) +
        ' ' +
        t('checkIn:totalAlerts', { count: alerts.length })
      }
    >
      <Box sx={styles.showAllContainer}>
        <Box sx={styles.alertHeaderContainer}>
          <Typography typography="header3" color="gray.80">
            {alerts.length} {t('checkIn:alerts.notesAndPropertiesAlerts.customProperties')}
          </Typography>
        </Box>
      </Box>
      {alerts.map((item, index) => (
        <React.Fragment key={item.id}>
          <Box sx={styles.showAllContainer}>
            <PropertyAlert title={verifyTitle(item)} description={item.value} />
          </Box>
          {index !== alerts.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </DialogLayout>
  )
}

export default ModalShowAllProperties

ModalShowAllProperties.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  username: PropTypes.string,
}
